const initialState = {
    jobItems: [],
    loading: false,
  };
  
  export default function jobReducer(state = initialState, action) {
    switch (action.type) {
      case "FETCH_JOB_ITEMS_REQUEST":
        return { ...state, loading: true };
      case "FETCH_JOB_ITEMS_SUCCESS":
        return { ...state, jobItems: action.payload, loading: false };
      case "FETCH_JOB_ITEMS_FAILURE":
        return { ...state, loading: false };
      default:
        return state;
    }
  }
  